import { render } from "./SignupForm.vue?vue&type=template&id=389da8c6&scoped=true"
import script from "./SignupForm.vue?vue&type=script&lang=js"
export * from "./SignupForm.vue?vue&type=script&lang=js"

import "./SignupForm.vue?vue&type=style&index=0&id=389da8c6&lang=scss&scoped=true"
import "./SignupForm.vue?vue&type=style&index=1&id=389da8c6&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389da8c6"]])

export default __exports__